const { modalClose, launchModal } = require('util/modalManager');
const { fillWithDomElements } = require('util/functions');

const CLASS_VIDEO = 'video';
const CLASS_PICTURE = 'still-picture';

const selectors = {
	videos: CLASS_VIDEO,
	picture: CLASS_PICTURE,
};
module.exports = {
	init() {
		this.root.__controller = this;
		this.opened = false;
		fillWithDomElements(this, selectors);
	},
	async open() {
		if (this.opened) return;
		launchModal({
			contentContainer: this.root,
			onClose: this.close.bind(this, true),
			remain: false,
		});
		this.opened = true;
	},

	close(preventModalClose) {
		if (!this.opened) return;
		if (
			this.videos?.__controller.video &&
			this.videos?.__controller.video.playing
		)
			this.videos?.__controller.video.pause();
		!preventModalClose && modalClose();
		this.opened = false;
	},
};
